import { render, staticRenderFns } from "./desking.vue?vue&type=template&id=4901291c"
import script from "./desking.vue?vue&type=script&lang=js"
export * from "./desking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports